module.exports = __webpack_public_path__ + "media/images/pic/lectors/justyna-szybinska-big-ef92732111f97d971809489c8ecc0273.jpeg";